import {
  IconArt,
  IconBook,
  IconDesktop,
  IconEvent,
  IconFood,
  IconGraduation,
  IconMusic,
  IconReceipt,
  IconScience,
  IconSports,
  IconSupplies,
  IconTheater,
  IconTransportation,
  IconUniform,
} from 'ui-icons';

/**
 * Mapping of icon API names to the icons.
 */
const ICON_API_MAP = {
  receipt: IconReceipt,
  book: IconBook,
  desktop: IconDesktop,
  supplies: IconSupplies,
  transportation: IconTransportation,
  graduation: IconGraduation,
  science: IconScience,
  art: IconArt,
  sports: IconSports,
  theater: IconTheater,
  music: IconMusic,
  uniform: IconUniform,
  food: IconFood,
  event: IconEvent,
} as const;

export { ICON_API_MAP };
